import { calendarBoardTasksFolderName } from './getTaskFolderName.locstring.json';
import loc from 'owa-localize';

export default function getTaskFolderName(projectName: string): string {
    return loc(calendarBoardTasksFolderName, projectName);
}
